import * as z from "zod";
import type { TFunction } from "i18next";

export const adminLicenseAssignmentFilterSchema = z.object({
  complex: z.string().default(""),
  structure: z.string().default(""),
  module: z.string().default(""),
  user: z.string().default(""),
});

export type AdminLicenseAssignmentFilterData = z.infer<
  typeof adminLicenseAssignmentFilterSchema
>;

export const assignLicenseSchema = (t: TFunction) =>
  z.object({
    assigneeUserId: z
      .string({
        required_error: t(
          "admin.licenseAssignments.form.validation.userRequired",
        ),
      })
      .min(1, t("admin.licenseAssignments.form.validation.userRequired")),
    licenseId: z
      .string({
        required_error: t(
          "admin.licenseAssignments.form.validation.licenseRequired",
        ),
      })
      .min(1, t("admin.licenseAssignments.form.validation.licenseRequired")),
  });

export type AssignLicenseFormData = z.infer<
  ReturnType<typeof assignLicenseSchema>
>;
